module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [(_vm.$store.state.user.user.username === 'ict' || _vm.$store.state.user.user.username === 'weian') ? _c('div', {
    staticClass: "col-6"
  }, [_c('h5', [_vm._v("匯入" + _vm._s(_vm.title) + "資訊")]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "fileupload"
    }
  }, [_vm._v("請選擇欲上傳的excel檔案")]), _c('input', {
    staticClass: "form-control-file",
    attrs: {
      "id": "fileupload",
      "type": "file",
      "name": "medtable"
    },
    on: {
      "change": _vm.onChange
    }
  })]), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("上傳檔案")])]) : _vm._e(), _c('div', {
    staticClass: "col-6"
  }, [_c('h5', [_vm._v("匯出" + _vm._s(_vm.title) + "資訊")]), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    on: {
      "click": _vm.download
    }
  }, [_vm._v("下載資料庫")])])]), _c('div', {
    staticClass: "col-12"
  }, [_c('hr'), (_vm.uploadProgress !== 0) ? _c('h6', [_vm._v("上傳中...")]) : _vm._e(), (_vm.uploadProgress !== 0) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: ({
      width: (_vm.uploadProgress + "%")
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.uploadProgress,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]) : _vm._e(), (_vm.resultMsg.length !== 0) ? _c('p', [_vm._v("上傳結果:")]) : _vm._e(), _vm._l((_vm.resultMsg), function(msg) {
    return _c('p', {
      staticStyle: {
        "margin": "0"
      }
    }, [_vm._v(_vm._s(msg))])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eea6c9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/DataImport/DataImportBase.vue
// module id = 1447
// module chunks = 1